import React, { useMemo } from 'react';
import './PixieDust.css';

// Gold motes drifting up through a hero band. Positions and timings are derived
// from the index rather than Math.random(), so they stay put across re-renders
// instead of jumping every time the parent updates.
const PixieDust = ({ count = 12, className = '' }) => {
  const motes = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: `${((i + 0.5) * (100 / count) + (((i * 37) % 9) - 4)).toFixed(2)}%`,
        delay: `${((i * 1.73) % 8).toFixed(2)}s`,
        duration: `${9 + ((i * 3) % 6)}s`,
        size: `${3 + ((i * 2) % 3)}px`,
        drift: `${(((i * 5) % 7) - 3) * 7}px`,
      })),
    [count]
  );

  return (
    <div className={`pixie-dust ${className}`.trim()} aria-hidden="true">
      {motes.map((mote, i) => (
        <span
          key={i}
          className="pixie-mote"
          style={{
            left: mote.left,
            width: mote.size,
            height: mote.size,
            animationDelay: mote.delay,
            animationDuration: mote.duration,
            '--drift': mote.drift,
          }}
        />
      ))}
    </div>
  );
};

export default PixieDust;
